import { useEffect, useMemo } from 'react';
import { useSelector } from 'react-redux';

import {
    type SidebarLink,
    menuLinks,
    selectIsAdmin,
    selectIsLoggedIn,
    selectIsOwner,
} from '@cloud/shared';

import { getDocumentationMenu } from './utils';

export function useMenuLinks() {
    const isLoggedIn = useSelector(selectIsLoggedIn);
    const isOwner = useSelector(selectIsOwner);
    const isAdmin = useSelector(selectIsAdmin);

    useEffect(() => {
        if (isLoggedIn && (isOwner || isAdmin)) {
            setTimeout(() => {
                document.body.classList.add('sidebar-loaded');
            }, 50);
        }
    }, [isAdmin, isOwner, isLoggedIn]);

    const links: SidebarLink[] = useMemo(() => {
        if (isAdmin || isOwner) {
            return [
                menuLinks.status,
                menuLinks.users,
                menuLinks.network,
                menuLinks.hosts,
                menuLinks.access,
                menuLinks.shieldV2,
                menuLinks.publishing,
                menuLinks.apiAndLogs,
                menuLinks.settings,
                getDocumentationMenu(isAdmin),
                menuLinks.getConnected,
            ];
        }

        return [menuLinks.devices, menuLinks.instructions];
    }, [isAdmin, isOwner]);

    const linksMap = useMemo(() => {
        const flatLinks = links.flatMap(t => (t.children ? Object.values(t.children) : t));
        const linksMap = new Map(flatLinks.map(t => [t.to, t]));
        return linksMap;
    }, [links]);

    return { links, linksMap };
}
